// @generated
// This file is automatically generated by Kanel. Do not modify manually.
import { operatorId } from './Operator';
import { brewSensoryFormId } from './BrewSensoryForm';
import { z } from 'zod';
export const brewSensoryTemplateId = (z.number());
export const brewSensoryTemplate = z.object({
    id: brewSensoryTemplateId,
    name: z.string(),
    instructions: z.string().nullable(),
    aroma_enabled: z.boolean(),
    taste_enabled: z.boolean(),
    archived_at: z.date().nullable(),
    archived_by: operatorId.nullable(),
    created_by: operatorId.nullable(),
    last_updated_by: operatorId.nullable(),
    created_at: z.date(),
    updated_at: z.date(),
    aroma_form_id: brewSensoryFormId.nullable(),
    taste_form_id: brewSensoryFormId.nullable(),
});
export const brewSensoryTemplateInitializer = z.object({
    id: brewSensoryTemplateId.optional(),
    name: z.string(),
    instructions: z.string().optional().nullable(),
    aroma_enabled: z.boolean().optional(),
    taste_enabled: z.boolean().optional(),
    archived_at: z.date().optional().nullable(),
    archived_by: operatorId.optional().nullable(),
    created_by: operatorId.optional().nullable(),
    last_updated_by: operatorId.optional().nullable(),
    created_at: z.date().optional(),
    updated_at: z.date().optional(),
    aroma_form_id: brewSensoryFormId.optional().nullable(),
    taste_form_id: brewSensoryFormId.optional().nullable(),
});
export const brewSensoryTemplateMutator = z.object({
    id: brewSensoryTemplateId.optional(),
    name: z.string().optional(),
    instructions: z.string().optional().nullable(),
    aroma_enabled: z.boolean().optional(),
    taste_enabled: z.boolean().optional(),
    archived_at: z.date().optional().nullable(),
    archived_by: operatorId.optional().nullable(),
    created_by: operatorId.optional().nullable(),
    last_updated_by: operatorId.optional().nullable(),
    created_at: z.date().optional(),
    updated_at: z.date().optional(),
    aroma_form_id: brewSensoryFormId.optional().nullable(),
    taste_form_id: brewSensoryFormId.optional().nullable(),
});
//# sourceMappingURL=BrewSensoryTemplate.js.map